export default __webpack_public_path__ + "static/media/phone-in-hand.fe2aadcd.png";